import { connect, } from 'react-redux';
import ScreenSizeContextProvider from './ScreenSizeContext';
import { MeasuredCookieType } from '../redux/types';
import { makeGetPrevLoadDims } from '../redux/selectors';
import { updateMeasuredCookie } from '../redux/actions';
var makeMapStateToProps = function () {
    var getPrevLoadDims = makeGetPrevLoadDims();
    return function (state) {
        return {
            prevLoadDims: getPrevLoadDims(state, MeasuredCookieType.SCREEN_WIDTH, 'width'),
        };
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    onUpdatedDims: function (size) {
        dispatch(updateMeasuredCookie(MeasuredCookieType.SCREEN_WIDTH, 'width', {
            width: size.width,
            height: 0,
        }));
    },
}); };
var container = connect(makeMapStateToProps, mapDispatchToProps);
var ScreenSizeContextProviderContainer = container(ScreenSizeContextProvider);
ScreenSizeContextProviderContainer.displayName = 'ScreenSizeContextContainer';
export default ScreenSizeContextProviderContainer;
//# sourceMappingURL=ScreenSizeContext.container.js.map